export default "__VITE_ASSET__82d6c81f__"